import React, { createContext } from "react"
import { useState } from "react"

const SurfaceLayerContext = createContext()
export default SurfaceLayerContext

export function SurfaceLayerProvider({ ...props }) {
    const [surfaceLayer, setSurfaceLayer] = useState('')
    return <SurfaceLayerContext.Provider value={[surfaceLayer, setSurfaceLayer]} {...props} />
}